import { initWidgets } from '~/registry/widgets';

import { alfaBankManifests } from './manifests-imports';

/** инициализация виджетов для клиентской части приложения */
(() => {
    initWidgets([alfaBankManifests]);
})();
